import React from "react";

export default function BsCurrencyBitcoin() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 19.582v1.875c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.875h.75v1.875c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.875h.126c2.988 0 5.124-1.55 5.124-4.23 0-2.253-1.51-3.485-3.28-3.66v-.132c1.456-.363 2.525-1.461 2.525-3.285 0-2.298-1.725-3.693-4.357-3.693H13.5V2.707a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.875h-.86V2.707a.375.375 0 0 0-.375-.375h-1.39a.375.375 0 0 0-.375.375v1.875l-2.997.017a.375.375 0 0 0-.375.375v1.483c0 .206.165.375.372.375l1.132-.007A1.125 1.125 0 0 1 7.5 7.95v8.257a1.125 1.125 0 0 1-1.125 1.125l-1.122.017a.375.375 0 0 0-.375.375v1.5c0 .206.168.375.375.375l2.997-.017Zm2.14-12.77h2.579c1.359 0 2.157.748 2.157 1.969 0 1.306-.863 2.042-2.816 2.042h-1.92v-4.01Zm0 6.077h2.76c1.706 0 2.634.87 2.634 2.286 0 1.43-.939 2.175-3.237 2.175H10.39v-4.461Z"
        fill="#currentColor"
      />
    </svg>
  );
}
